<nav aria-label="Page navigation example">
    <ul class="pagination justify-content-end mb-0 manualMobile">
        <li class="page-item" [ngClass]="{'disabled': page.pageNumber==1}"
            (click)="setPagination('first', page.pageNumber, page.pageCount)">
            <a class="page-link" aria-label="Previous">
                <span aria-hidden="true">&laquo;</span>
                <span class="sr-only">Previous</span>
            </a>
        </li>
        <!-- <li class="page-item" [ngClass]="{'disabled': page.pageNumber<=10}" *ngIf="page.pageCount > 10"
            (click)="setPagination('increase', (page.pageNumber - 10), page.pageCount)">
            <a class="page-link" aria-label="Previous"> 
                <span>-10</span>
            </a>
        </li> -->
        <li class="page-item" [ngClass]="{'disabled': page.pageNumber==1}"
            (click)="setPagination('prev', page.pageNumber, page.pageCount)">
            <a class="page-link" aria-label="Previous">
                <span aria-hidden="true">&lt;</span>
            </a>
        </li>

        <li class="page-item" [ngClass]="{'active': pgp.active}" *ngFor="let pgp of pageList" (click)="goPageObj(pgp)">
            <a class="page-link">{{pgp.num }}</a>
        </li>

        <li class="page-item" [ngClass]="{'disabled': page.pageNumber==page.pageCount}"
            (click)="setPagination('next', page.pageNumber, page.pageCount)">
            <a class="page-link" aria-label="Next">
                <span aria-hidden="true">&gt;</span>
            </a>
        </li>

        <!-- <li class="page-item" [ngClass]="{'disabled': page.pageNumber>(page.pageCount-10)}" *ngIf="page.pageCount > 10"
            (click)="setPagination('reduce', (page.pageNumber + 10), (page.pageCount-10))">
            <a class="page-link" aria-label="Next">
                <span>+10</span>
            </a>
        </li> -->

        <li class="page-item" [ngClass]="{'disabled': page.pageNumber==page.pageCount}"
            (click)="setPagination('last', page.pageNumber, page.pageCount)">
            <a class="page-link" aria-label="Next">
                <span aria-hidden="true">&raquo;</span>
                <span class="sr-only">Next</span>
            </a>
        </li>
    </ul>
</nav>